import { Component } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxComponent } from '@group24ag/flowkit';

@Component({
  selector: 'app-ui-checkboxes',
  imports: [CheckboxComponent, FormsModule, ReactiveFormsModule],
  template: `
    <h1 class="heading-title">Checkboxes</h1>
    <div class="flex flex-col gap-y-2">
      <div>
        <h2 class="heading-title--small">Enabled</h2>
        <div class="flex flex-row gap-x-2">
          <flk-checkbox [(ngModel)]="model" />
          <flk-checkbox [indeterminate]="true" />
          <flk-checkbox [checked]="true" [indeterminate]="true" />
          <flk-checkbox />
        </div>
      </div>
      <div>
        <h2 class="heading-title--small">Disabled</h2>
        <div class="flex flex-row gap-x-2">
          <flk-checkbox [formControl]="control1" [indeterminate]="true" />
          <flk-checkbox [disabled]="true" [indeterminate]="true" />
          <flk-checkbox
            [disabled]="true"
            [checked]="true"
            [indeterminate]="true" />
          <flk-checkbox [disabled]="true" />
        </div>
      </div>
      <div>
        <h2 class="heading-title--small">Labeled</h2>
        <div class="flex flex-row gap-x-2">
          <flk-checkbox>Text</flk-checkbox>
          <flk-checkbox class="reverse">txeT</flk-checkbox>
        </div>
      </div>
    </div>
  `,
})
export class UICheckboxesComponent {
  model = true;
  control1 = new FormControl({ value: true, disabled: true });
}
